import { cn } from "@/utils/cn";

import {
  PAPERCLIP_ICON_PATH,
  PAPERCLIP_ICON_VIEWBOX,
} from "./paperclipIconPath";

// Heights preserve the glyph's previous rendered size (it used to occupy 70%
// of a 30/42/66px square box); width follows the glyph's aspect ratio.
const sizes = {
  sm: "h-[21px] w-auto",
  md: "h-[29px] w-auto",
  lg: "h-[46px] w-auto",
} as const;

type PaperclipLogoMarkProps = {
  size?: keyof typeof sizes;
  className?: string;
};

/**
 * The bare Paperclip glyph — no tile, square, or circle. It renders in
 * `currentColor`, defaulting to `text-zinc-900`, which the theme system remaps
 * per color scheme (light -> near-black, dark -> near-white, beige -> brown), so
 * the mark always contrasts whatever background it sits on. Pass a `text-*`
 * class to override (e.g. a faded ghost logo).
 */
export const PaperclipLogoMark = ({
  size = "md",
  className,
}: PaperclipLogoMarkProps) => (
  <svg
    viewBox={PAPERCLIP_ICON_VIEWBOX}
    fill="currentColor"
    className={cn("shrink-0 text-zinc-900", sizes[size], className)}
    aria-hidden
  >
    <path d={PAPERCLIP_ICON_PATH} />
  </svg>
);
